import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityMeetingItem: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['status-requested'], background = theme.colors['white'] }) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="23" height="23" rx="3.5" fill={background}/>
      <rect x="0.5" y="1" width="23" height="23" rx="3.5" stroke="#EAE9E8"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.4105 10.1666C11.4105 11.135 10.6347 11.9166 9.66634 11.9166C8.69801 11.9166 7.91634 11.135 7.91634 10.1666C7.91634 9.19829 8.69801 8.41663 9.66634 8.41663C10.6347 8.41663 11.4105 9.19829 11.4105 10.1666ZM16.0772 10.1666C16.0772 11.135 15.3013 11.9166 14.333 11.9166C13.3647 11.9166 12.583 11.135 12.583 10.1666C12.583 9.19829 13.3647 8.41663 14.333 8.41663C15.3013 8.41663 16.0772 9.19829 16.0772 10.1666ZM9.66634 13.0833C8.30717 13.0833 5.58301 13.7658 5.58301 15.125V16.5833H13.7497V15.125C13.7497 13.7658 11.0255 13.0833 9.66634 13.0833ZM13.7672 13.1125C13.9713 13.095 14.1638 13.0833 14.333 13.0833C15.6922 13.0833 18.4163 13.7658 18.4163 15.125V16.5833H14.9163V15.125C14.9163 14.2616 14.4438 13.6025 13.7672 13.1125Z" fill={fill} />
    </svg>
  )
);
